// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"44105b7e","272":"5d958a06","448":"4ba549c8","811":"e54fa752"}[chunkId] + ".css";
};